import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "giftregistrytypesearch-query"
    }}>{`giftRegistryTypeSearch query`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`giftRegistryTypeSearch`}</inlineCode>{` query returns a list of gift registries that match the specified registrant name and, optionally, registry type ID. Use the `}<a parentName="p" {...{
        "href": "types.md"
      }}><inlineCode parentName="a">{`giftRegistryTypes`}</inlineCode>{` query`}</a>{` to return list of registry type IDs.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`giftRegistryTypeSearch(
    firstName: String!
    lastName: String!
    giftRegistryTypeUid: String
): [GiftRegistrySearchResult]
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#query-giftRegistryTypeSearch"
      }}><inlineCode parentName="a">{`giftRegistryTypeSearch`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this query.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example returns all gift registries in which the specified person is a registrant.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`query{
  giftRegistryTypeSearch(firstName: "Stacey", lastName: "Gaines"){
    event_date
    event_title
    gift_registry_uid
    name
    type
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "giftRegistryTypeSearch": [
      {
        "event_date": "2021-01-28",
        "event_title": "Theo's 45th Birthday",
        "gift_registry_uid": "W9YcRai9JmzGglqP3p0USodTTM3BmjjY",
        "name": "Stacey Gaines",
        "type": "Birthday"
      }
    ]
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      